/**
 * @generated SignedSource<<4acf6c250f92d79a2d29239ef9cf001c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WATaskSingleSettingsSelectTaskQuery$variables = {
  routineId: string;
};
export type WATaskSingleSettingsSelectTaskQuery$data = {
  readonly routine: {
    readonly activeVersion: {
      readonly id: string;
      readonly tasks: ReadonlyArray<{
        readonly __typename: string;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"TaskListItemIcon_Task" | "TaskListItemTitle_Task">;
      }>;
    };
    readonly id: string;
    readonly title: string;
  } | null;
};
export type WATaskSingleSettingsSelectTaskQuery = {
  response: WATaskSingleSettingsSelectTaskQuery$data;
  variables: WATaskSingleSettingsSelectTaskQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "routineId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "routineId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "WATaskSingleSettingsSelectTaskQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineVersion",
            "kind": "LinkedField",
            "name": "activeVersion",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tasks",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TaskListItemIcon_Task"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "TaskListItemTitle_Task"
                  },
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "WATaskSingleSettingsSelectTaskQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Routine",
        "kind": "LinkedField",
        "name": "routine",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RoutineVersion",
            "kind": "LinkedField",
            "name": "activeVersion",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tasks",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isTask"
                  },
                  (v4/*: any*/),
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "unit",
                        "storageKey": null
                      }
                    ],
                    "type": "TaskNumber",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "sentiments",
                        "storageKey": null
                      }
                    ],
                    "type": "TaskCheck",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "f5ee156ae6e1999141f06069ebe97d65",
    "id": null,
    "metadata": {},
    "name": "WATaskSingleSettingsSelectTaskQuery",
    "operationKind": "query",
    "text": "query WATaskSingleSettingsSelectTaskQuery(\n  $routineId: ID!\n) {\n  routine(id: $routineId) {\n    id\n    title\n    activeVersion {\n      id\n      tasks {\n        id\n        ...TaskListItemIcon_Task\n        ...TaskListItemTitle_Task\n        __typename\n      }\n    }\n  }\n}\n\nfragment TaskListItemIcon_Task on Task {\n  __isTask: __typename\n  __typename\n  ... on TaskNumber {\n    unit\n  }\n  ... on TaskCheck {\n    sentiments\n  }\n  ... on TaskText {\n    __typename\n  }\n}\n\nfragment TaskListItemTitle_Task on Task {\n  __isTask: __typename\n  title\n}\n"
  }
};
})();

(node as any).hash = "c07ebab44c962695d0f091ea05613691";

export default node;
